<template>
    <div class="survey-box">
        <div v-if="sent" class="survey-finish">
            <p>Vielen Dank!</p>
        </div>
        <div v-else>
            <div class="survey-header">
                <h2>Wenn du schon hier bist …</h2>
                <p>
                    würdest du uns noch diese drei Fragen beantworten?
                </p>
            </div>

            <div class="form-group">
                <span class="label">Welche Sorte AMECKE Saft hast du als Aktionspackung gekauft?</span>
                <label for="question_1"></label>
                <div class="select-wrapper">
                    <select id="question_1" name="question_1" v-model="questions.question_1">
                        <option value="">Bitte wählen</option>
                        <option value="1">AMECKE Sanfte Säfte Apfel Birne</option>
                        <option value="2">AMECKE Sanfte Säfte Apfel klar filtriert</option>
                        <option value="3">AMECKE Sanfte Säfte Apfel naturtrüb</option>
                        <option value="4">AMECKE Sanfte Säfte Erdbeere Apfel</option>
                        <option value="5">AMECKE Sanfte Säfte Himbeer Johannisbeer Apfel</option>
                        <option value="6">AMECKE Sanfte Säfte Mandarine Orange</option>
                        <option value="7">AMECKE Sanfte Säfte Mango Apfel Orange</option>
                        <option value="8">AMECKE Sanfte Säfte Multivitamin</option>
                        <option value="9">AMECKE Sanfte Säfte Orange</option>
                        <option value="10">AMECKE Sanfte Säfte Orange mit feinem Fruchtfleisch</option>
                        <option value="11">AMECKE Sanfte Säfte Pfirsich Mandarine</option>
                        <option value="12">AMECKE Sanfte Säfte Pink Grapefruit mit mildem Apfel</option>
                        <option value="13">AMECKE Sanfte Säfte Tomate</option>
                        <option value="14">AMECKE Sanfte Säfte Traube rosé Apfel</option>
                        <option value="15">AMECKE PLUS Eisen tiefrot</option>
                        <option value="16">AMECKE PLUS Eisen hellrot</option>
                        <option value="17">AMECKE PLUS Antioxidantien rot</option>
                        <option value="18">AMECKE PLUS Antioxidantien gelb</option>
                        <option value="19">AMECKE PLUS Zink</option>
                        <option value="20">AMECKE PLUS Vitamin D</option>
                        <option value="21">AMECKE PLUS Calcium Magnesium</option>
                        <option value="22">AMECKE PLUS Folsäure</option>
                        <option value="23">AMECKE PLUS FÜR IHN</option>
                        <option value="24">AMECKE PLUS FÜR SIE</option>
                        <option value="25">AMECKE PLUS Aktiv Ballaststoffe</option>
                        <option value="26">AMECKE PLUS COLLAGEN Aloe vera</option>
                        <option value="27">AMECKE PLUS COLLAGEN Antioxidantien</option>
                    </select>
                </div>
            </div>

            <div class="form-group">
                <span class="label">Hast du vorher schon AMECKE Säfte gekauft?</span>
                <label for="question_2"></label>
                <div class="select-wrapper">
                    <select id="question_2" name="question_2" v-model="questions.question_2">
                        <option value="">Bitte wählen</option>
                        <option value="1">ja</option>
                        <option value="2">nein</option>
                        <option value="3">weiß nicht</option>
                    </select>
                </div>
            </div>

            <div class="form-group">
                <span class="label">Würdest du unsere <em>mehr leben</em> Freizeit-Aktion weiter empfehlen?</span>
                <label for="question_3"></label>
                <div class="select-wrapper">
                    <select id="question_3" name="question_3" v-model="questions.question_3">
                        <option value="">Bitte wählen</option>
                        <option value="1">ja</option>
                        <option value="2">nein</option>
                        <option value="3">weiß nicht</option>
                    </select>
                </div>
            </div>

            <div class="pull-right">
                <button type="submit" class="btn btn-circle" @click="sendForm" :disabled="!isValid"><span>senden</span></button>
            </div>
        </div>
    </div>
</template>

<script>
import api from "../api";

export default {
    name: "SurveyBox",

    data() {
        return {
            sent: false,
            questions: {
                question_1: 0,
                question_2: 0,
                question_3: 0,
            }
        }
    },

    computed: {
        isValid() {
            return this.questions.question_1 > 0
                && this.questions.question_2 > 0
                && this.questions.question_3 > 0;
        }
    },

    methods: {
        sendForm() {
            this.sent = true;
            api.poll(this.questions);
        }
    },

    created() {
        this.sent = api.hasSubmittedPoll();
    }
}
</script>
